module.exports = __webpack_public_path__ + "img/next-arrow.ef782c32.svg";